import { jsx as _jsx } from "react/jsx-runtime";
import { useStyles } from '@kubit/web-ui-components/hooks/useStyles';
import * as React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { ProgressBarComplexStandAlone } from './progressBarComplexStandAlone';
const ProgressBarComplexComponent = (props, ref) => {
    const styles = useStyles(STYLES_NAME.PROGRESS_BAR_COMPLEX, props.variant);
    return _jsx(ProgressBarComplexStandAlone, { ...props, ref: ref, styles: styles });
};
export const ProgressBarComplex = React.forwardRef(ProgressBarComplexComponent);
//# sourceMappingURL=progressBarComplex.js.map